module.exports = __webpack_public_path__ + "img/9788952215642.ed854a99.jpg";